import { render } from "./SessionSpaceCounts.vue?vue&type=template&id=a48cbfe0"
import script from "./SessionSpaceCounts.vue?vue&type=script&lang=js"
export * from "./SessionSpaceCounts.vue?vue&type=script&lang=js"

import "./SessionSpaceCounts.vue?vue&type=style&index=0&id=a48cbfe0&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__